import { render, staticRenderFns } from "./seaBookingDischargingTrucking.vue?vue&type=template&id=1ffad4ae&scoped=true&"
import script from "./seaBookingDischargingTrucking.vue?vue&type=script&lang=js&"
export * from "./seaBookingDischargingTrucking.vue?vue&type=script&lang=js&"
import style0 from "./seaBookingDischargingTrucking.vue?vue&type=style&index=0&id=1ffad4ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffad4ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ffad4ae')) {
      api.createRecord('1ffad4ae', component.options)
    } else {
      api.reload('1ffad4ae', component.options)
    }
    module.hot.accept("./seaBookingDischargingTrucking.vue?vue&type=template&id=1ffad4ae&scoped=true&", function () {
      api.rerender('1ffad4ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUserUICustom/seaBookingDischargingTrucking.vue"
export default component.exports